<template>
  <div>

    <van-cell v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div>
          {{isRead ? current.value : current.value || '自动生成无需填写'}}
        </div>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__serial-num-compact">

      <van-field :label="current.title">
        <template #input>
          <div class="serial-num-container">
            {{isRead ? current.value : current.value || '自动生成无需填写'}}
          </div>
        </template>
      </van-field>
    </div>
  </div>
</template>

<script>
  import { current } from './mixin'

  export default {
    mixins: [current]
  }
</script>
